/**
 * Formatter murni untuk halaman detail ujian. Dipakai bareng oleh view server
 * (`server/exam-detail-view.tsx`) dan islands client
 * (`client/exam-detail-interactive.tsx`) — karena keduanya menampilkan nilai
 * turunan yang sama (durasi efektif, harga setelah diskon).
 *
 * Tanpa side-effect dan tanpa `'use client'` → aman diimpor dari RSC maupun
 * dari client bundle.
 */

export const formatPrice = (n: number) =>
  `Rp${Math.round(Number(n)).toLocaleString("id-ID")}`;

export const formatDuration = (m: number) => {
  if (m >= 60) {
    const h = Math.floor(m / 60);
    const r = m % 60;
    return r > 0 ? `${h}j ${r}m` : `${h} jam`;
  }
  return `${m} menit`;
};
